import { get } from '../fable'

export const getCreditBalance = async () => await get('/credit/balance')
